import { ref } from "vue";
import appApi from "@/services/api";
import { exceptionRequestMsg, showToast } from "@/assets/js/util";

const useDashboard = () => {
  const consultandoGraficas = ref(false);
  const showCharts = ref(false);
  const chartArrendamientoTotal = ref([]);
  const chartArrendamientoData = ref([]);
  const chartLineaClienteLabels = ref([]);
  const chartLineaClienteData = ref([]);
  const chartEstatusLabels = ref([]);
  const chartEstatusData = ref([]);
  const chartOrigenLabels = ref([]);
  const chartOrigenData = ref([]);
  const chartColors = ref([
    "#fd7f6f",
    "#7eb0d5",
    "#b2e061",
    "#bd7ebe",
    "#ffb55a",
    "#ffee65",
    "#beb9db",
    "#fdcce5",
    "#8bd3c7",
  ]);

  const consultaGraficas = async () => {
    const form = document.getElementById("formCharts");
    showCharts.value = false;
    const formData = new FormData(form);
    consultandoGraficas.value = true;
    try {
      const response = await appApi().post(`dashboard/getCharts`, formData);

      if (!response.data.status) {
        showToast(response.data.message, "error");
        return;
      }

      const {
        chartArrendamientos,
        chartClientes,
        chartEstatus,
        chartOrigen,
      } = response.data;
      chartArrendamientoData.value = chartArrendamientos.map(
        (val) => val.arrendamiento
      );
      chartArrendamientoTotal.value = chartArrendamientos.map(
        (val) => val.total
      );

      chartLineaClienteLabels.value = chartClientes.map((val) => val.linea);
      chartLineaClienteData.value = chartClientes.map((val) => val.total);

      chartEstatusLabels.value = chartEstatus.map((val) => val.estatus);
      chartEstatusData.value = chartEstatus.map((val) => val.total);

      chartOrigenLabels.value = chartOrigen.map((val) => val.residencia);
      chartOrigenData.value = chartOrigen.map((val) => val.total);

      showCharts.value = true;
    } catch (e) {
      showCharts.value = false;
      console.log(e);
      exceptionRequestMsg(e);
    } finally {
      consultandoGraficas.value = false;
    }
  };

  const chartsOptions = ref({
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
    },
    interaction: {
      intersect: false,
      mode: "index",
    },
    scales: {
      y: {
        grid: {
          drawBorder: false,
          display: true,
          drawOnChartArea: true,
          drawTicks: false,
          borderDash: [5, 5],
        },
        ticks: {
          display: true,
          padding: 10,
          color: "#fbfbfb",
          font: {
            size: 11,
            family: "Open Sans",
            style: "normal",
            lineHeight: 2,
          },
        },
      },
      x: {
        grid: {
          drawBorder: false,
          display: false,
          drawOnChartArea: false,
          drawTicks: false,
          borderDash: [5, 5],
        },
        ticks: {
          display: true,
          color: "#ccc",
          padding: 20,
          font: {
            size: 11,
            family: "Open Sans",
            style: "normal",
            lineHeight: 2,
          },
        },
      },
    },
  });

  return {
    consultaGraficas,
    consultandoGraficas,
    chartsOptions,
    chartArrendamientoData,
    chartArrendamientoTotal,
    chartLineaClienteLabels,
    chartLineaClienteData,
    chartEstatusLabels,
    chartEstatusData,
    chartOrigenLabels,
    chartOrigenData,
    chartColors,
    showCharts,
  };
};

export default useDashboard;
